import { Badge } from "antd";
import { baseMenuItems } from "./menuBase";
import { adminMenuItems } from "./menuAdmin";
import { MENU_VISIBILITY_BY_COUNTRY } from "./menuByCountry";
import { getCajeroHiddenMenu, isCajero } from "../rbac/rbac.config";
import { ItemType } from "antd/es/menu/interface";
import { configuracionDePais } from "../../utils/configuracionDePais";

const filterMenu = (items: ItemType[], hiddenKeys: any[] = []) => {
  return items
    .filter((item) => !hiddenKeys.includes(item!.key))
    .map((item: any) => {
      if (item!.children) {
        return {
          ...item,
          children: item!.children.filter((child: any) => !hiddenKeys.includes(child.key)),
        };
      }
      return item;
    });
};

// La clave del ítem «Pendientes de sincronizar». Vive acá y no suelta en el
// componente porque es lo único que ata este aviso a esa fila del menú.
const CLAVE_PENDIENTES = "5.5";

/**
 * Pone el número de documentos sin enviar junto a su ítem.
 *
 * Ese ítem existe para avisar de que algo quedó sin viajar, y hasta ahora había
 * que entrar para saberlo. Con la barra oculta por omisión, además, ni siquiera
 * se pasa por delante.
 *
 * Sin pendientes no se dibuja nada: un cero permanente enseña a no mirar.
 */
const conAvisoDePendientes = (items: any[], pendientes: number): any[] => {
  if (!pendientes) return items;

  return items.map((item: any) => {
    if (!item?.children) return item;
    return {
      ...item,
      children: item.children.map((hijo: any) =>
        hijo?.key === CLAVE_PENDIENTES
          ? {
              ...hijo,
              label: (
                <>
                  {hijo.label}
                  <Badge
                    count={pendientes}
                    overflowCount={99}
                    size="small"
                    style={{ marginLeft: 8 }}
                  />
                </>
              ),
            }
          : hijo
      ),
    };
  });
};

export const getMenuItems = ({ isAdmin, country, pendientes = 0 }: any) => {
  const countryRules = configuracionDePais(MENU_VISIBILITY_BY_COUNTRY, country?.code, "menú");

  // Se parte del menú entero y se recorta: quién ve qué lo decide la tabla de
  // rbac.config, no la separación entre estos dos archivos, que hoy es sólo el
  // orden en que están escritos los ítems.
  let items = [...baseMenuItems, ...adminMenuItems].sort((a, b) =>
    a!.key!.toString().localeCompare(b!.key!.toString(), undefined, {
      numeric: true,
      sensitivity: "base",
    })
  );

  const hiddenKeys = [
    ...(countryRules.hide || []),
    ...(isCajero(country?.code, isAdmin) ? getCajeroHiddenMenu(country?.code) : []),
  ];

  if (hiddenKeys.length) {
    items = filterMenu(items, hiddenKeys);
  }

  return conAvisoDePendientes(items, pendientes);
};
